import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

export function TextForm() {
    const { isFormDisabled, form } = useFieldFormContext();

    return (
        <div className="flex flex-col gap-2">
            <FormField
                name="field_min"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Minimum length</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                min={0}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_max"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Maximum length</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                min={0}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
}